<div class="modal-overlay" (click)="onClose()">
  <div class="pair-dialog" (click)="$event.stopPropagation()">

    <div class="pair-dialog-header">
      <div class="pair-dialog-titles">
        <h2>{{ isRejected ? 'Unpaired bills' : 'Paired bills' }}</h2>
        <span class="pair-dialog-subtitle">{{ subtitle }}</span>
      </div>
      <button type="button" class="close-btn" (click)="onClose()" aria-label="Close">
        <i class="material-symbols-rounded">close</i>
      </button>
    </div>

    <div class="pair-dialog-cols">
      <div class="pair-col">
        <app-bill-type-badge [type]="'utility'"></app-bill-type-badge>
        <div class="pair-col-name">{{ utilityCard.name }}</div>
        <div class="pair-col-amount">{{ utilityCard.amount }}</div>
        <div class="pair-col-file" [title]="utilityCard.fileName">{{ utilityCard.fileName }}</div>
      </div>
      <div class="pair-col">
        <app-bill-type-badge [type]="'supplier'"></app-bill-type-badge>
        <div class="pair-col-name">{{ supplierCard.name }}</div>
        <div class="pair-col-amount">{{ supplierCard.amount }}</div>
        <div class="pair-col-file" [title]="supplierCard.fileName">{{ supplierCard.fileName }}</div>
      </div>
    </div>

    <div class="pair-dialog-total">
      <span class="total-label">Combined total</span>
      <span class="total-value">{{ combinedAmount }}</span>
    </div>

    <div class="pair-dialog-footer">
      @if (isRejected) {
        <button type="button" class="btn-secondary" (click)="onClose()">Keep separate</button>
        <button type="button" class="btn-primary" (click)="onPair()">Pair bills</button>
      } @else {
        <button type="button" class="btn-secondary" (click)="onUnpair()">Not a match</button>
        <button type="button" class="btn-primary" (click)="onConfirm()">Keep paired</button>
      }
    </div>
  </div>
</div>
